import React from "react";
import PropTypes from "prop-types";
import { formatTimelineTime } from "../../../util/timelineHelper";

/**
 * Hop/ingredient drop child entry
 */
const HopDropEntry = ({ child }) => {
  const icon = child.isHop ? "🌿" : child.type === "YEAST" ? "🧫" : "📦";

  return (
    <div className="brew-timeline__child">
      <span className="brew-timeline__child-name">
        <span className="brew-timeline__child-icon">{icon}</span>
        {child.label}
      </span>
      <span className="brew-timeline__child-detail">
        {child.dropTime && (
          <span className="brew-timeline__child-time">
            {formatTimelineTime(child.dropTime)}
          </span>
        )}
        {child.durationLabel && !child.dropTime && (
          <span className="brew-timeline__child-time">
            {child.durationLabel}
          </span>
        )}
      </span>
    </div>
  );
};

HopDropEntry.propTypes = {
  child: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isHop: PropTypes.bool,
    type: PropTypes.string,
    label: PropTypes.string,
    dropTime: PropTypes.instanceOf(Date),
    durationLabel: PropTypes.string,
  }),
};

export default HopDropEntry;
